const getters = {
  scWorkGroups: state => state.sc_work_groups,
  scWorkGroup: state => state.sc_work_group,
  scWorkGroupFilters: state => state.sc_work_group_filters,
}

export default getters;
